import { render, staticRenderFns } from "./RecordingEditModal.vue?vue&type=template&id=944e8cd8&scoped=true&"
import script from "./RecordingEditModal.vue?vue&type=script&lang=js&"
export * from "./RecordingEditModal.vue?vue&type=script&lang=js&"
import style0 from "./RecordingEditModal.vue?vue&type=style&index=0&id=944e8cd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944e8cd8",
  null
  
)

export default component.exports